import { render } from "./SearchItemDimension.vue?vue&type=template&id=b71e621c"
import script from "./SearchItemDimension.vue?vue&type=script&lang=ts"
export * from "./SearchItemDimension.vue?vue&type=script&lang=ts"
script.render = render

export default script